module.exports = __webpack_public_path__ + "img/Favicon.d3d07854.svg";